import React from 'react';
import { useDispatch } from 'react-redux';
import {
	OrderInfo,
	ProductApi,
	Category,
	Languages,
	ShopPublicInfo,
	OrderInfoDelivery,
} from 'common/types';
import { RentalsTabValue } from 'services/types';
import { RentalLinkData } from 'services/types';

import { setRentalLinkSendingFailed, setPendingRentalLinks } from 'actions';
import { getCountryCode } from './getCountryCode';
import RentalCard from '../RentalCard';

import { Routes } from 'routing';

interface Props {
	rental: OrderInfo;
	index: number;
	rentalTab: RentalsTabValue;
	stockProducts: ProductApi[];
	categories: Category[];
	pendingLinks: RentalLinkData[];
	currentShopInfo: ShopPublicInfo;
	language: Languages;
	showExpired: boolean;
	showLocations: boolean;
	delivery?: OrderInfoDelivery;
}

const RentalCardContainer = (props: Props) => {
	const {
		rental,
		index,
		rentalTab,
		stockProducts,
		categories,
		currentShopInfo,
		language,
		pendingLinks,
		showExpired,
		delivery,
		showLocations,
	} = props;

	const dispatch = useDispatch();

	const rentalInfoToRentalLinkData = (rental: OrderInfo): RentalLinkData => {
		const { email, phone, linkId } = rental.rentalLink!;
		const lang = language as string;
		const langParam = lang ? `?lang=${lang}` : '';
		const rentalLinkUrl = `${window.location.protocol}//${window.location.host}/${linkId}${langParam}`;
		const country = getCountryCode(phone || '');
		return {
			shopPublicInfo: currentShopInfo,
			startLocation: rental.startLocation,
			email: email || '',
			phone: {
				numberWithoutCode: country
					? phone
						? phone.slice(country.dial_code.length)
						: ''
					: phone || '',
				areaCode: country ? country.dial_code : '+358',
				countryCode: country ? country.code : 'FI',
			},
			payLinkUrl: rentalLinkUrl,
			language: lang,
			rentalId: rental.id,
			status: 'failed',
		};
	};

	const { rentalLink } = rental;

	return (
		<RentalCard
			key={`${rental.id}${index}`}
			linkTo={Routes.BookingPage(rental.id)}
			rentalInfo={rental}
			rentalTab={rentalTab}
			categories={categories}
			stockProducts={stockProducts}
			onClick={(rentalId: string) => {
				const paylinkSendingFailed =
					(rentalLink &&
						rentalLink.phone &&
						!rentalLink.email && // If the link was sent by email, no need to worry about failed sms delivery
						rentalLink.smsDeliveryStatusHistory &&
						rentalLink.smsDeliveryStatusHistory.some((e) => e.status === 'failed') &&
						!rentalLink.smsDeliveryStatusHistory.some((e) => e.status === 'delivered')) ||
					false;
				if (paylinkSendingFailed) {
					dispatch(setRentalLinkSendingFailed(true));
					if (!pendingLinks.some((link) => link.rentalId === rentalId)) {
						dispatch(setPendingRentalLinks([...pendingLinks, rentalInfoToRentalLinkData(rental)]));
					}
				}
			}}
			dateExpired={showExpired}
			showLocations={showLocations}
			delivery={delivery}
		/>
	);
};

export default RentalCardContainer;
